import { Box } from '@material-ui/core';

import { FlightDetailsForm } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Flight/components/FlightForm/components/FlightDetailsForm';
import { PassengersForm } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Flight/components/FlightForm/components/PassengersForm';

export const FlightForm = () => {
  return (
    <Box width={'100%'}>
      <FlightDetailsForm />
      <PassengersForm />
    </Box>
  );
};
